import React from 'react'

import {
    DetailViewNotFoundEmptyState,
    DetailViewServerErrorEmptyState,
} from 'features/views/DetailView/DetailViewEmptyState'

import { useDetailViewLayoutState } from './hooks/useDetailViewLayoutState'
import { DetailViewCompactLayout } from './DetailViewCompactLayout'

type DetailViewLayoutProps = {}

export const DetailViewLayout: React.FC<DetailViewLayoutProps> = () => {
    const { layoutType, isError, onRetry, isNotFoundError } = useDetailViewLayoutState()

    if (isNotFoundError) {
        return <DetailViewNotFoundEmptyState />
    } else if (isError) {
        return <DetailViewServerErrorEmptyState onRetry={onRetry} />
    }

    switch (layoutType) {
        case 'compact':
            return <DetailViewCompactLayout />
        default:
            return null
    }
}
